import { ReactElement } from 'react'
import { useAtomValue } from 'jotai'
import { selectedAccountAtom } from 'store/atoms'
import AccountDetails from 'account-details-mfe'
import config from 'const/config'
import { accountDetailsModalContainerId } from 'const/modalContainerId'
import { getLanguageFromStorage } from 'helpers'
import triggerAnalyticsEvent from 'helpers/triggerAnalyticsEvent'
import { MFEConfig } from 'syf-js-utilities/typings/mfeConfig'
import findAccount from 'helpers/findAccount'
import { useAccountSummary, useCreditAccounts } from 'const/syfApiQueries'
import getHelpNumber from 'helpers/getHelpNumbers'
import { triggerOnCloseAnalytics } from 'helpers/triggerOnCloseAnalytics'
import { useNavigate } from 'react-router-dom'
import routes from 'const/routes'
import Loader from 'authorization-module/lib/ui/atoms/Loader'
import { getBrandRefreshPhase } from 'helpers/getBrandRefreshPhase'

const DetailsModal = (): ReactElement => {
  const selectedAccount = useAtomValue(selectedAccountAtom)

  const { data: { accounts = [] } = {} } = useCreditAccounts()
  const { data: accountSummary, isLoading: isAccountSummaryLoading } =
    useAccountSummary(selectedAccount)

  const navigate = useNavigate()

  const account = findAccount(accounts, selectedAccount)
  const isRegistered = account?.registration?.registered
  const clientId = accountSummary?.product?.clientId
  const { type: productType } = account?.product || {}
  const helpNumber = getHelpNumber(clientId, productType)

  const accountDetailsConfig: MFEConfig = {
    hosts: {
      apigee: new URL(config.API_HOST),
      assets: new URL(config.ASSETS_HOST)
    },
    apiErrorCallback: (err) => err,
    lang: getLanguageFromStorage()
  }

  const handleCloseModal = () => {
    triggerOnCloseAnalytics()
    navigate(routes.HOME)
  }

  if (isAccountSummaryLoading) {
    return <Loader />
  }

  return (
    <AccountDetails
      containerId={accountDetailsModalContainerId()}
      config={accountDetailsConfig}
      isModalOpen
      handleClose={handleCloseModal}
      selectedAccountId={selectedAccount}
      triggerAnalyticsEvent={triggerAnalyticsEvent}
      isRegistered={isRegistered}
      helpNumber={helpNumber}
      featureFlags={{
        brandRefreshPhase: getBrandRefreshPhase()
      }}
    />
  )
}

export default DetailsModal
